export enum ThemeName {
  Onmo = "ONMO",
  Dialog = "DIALOG",
  Zain = "Zain",
  Safaricom = "Safaricom",
  VodafoneIndia = "Vodafone India",
}
